module.exports = "<input-text \r\n    label=\"{{$ctrl.label}}\" \r\n    model=\"$ctrl.ogrn\" \r\n    on-init=\"$ctrl.onTextInit(domNode)\"\r\n    on-changed=\"$ctrl.onChanged(text)\"\r\n    have-error='$ctrl.haveError',\r\n    error-message='$ctrl.errorMessage'\r\n\r\n></input-text>"


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/html/ogrn.html
// module id = 79
// module chunks = 1